import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import QRCode from "qrcode" ;


const PreviewLerros = ({ show, onHide, content, count = 1, scale }) => {
  console.log('content ', content)

  const [qrCode, setQrCode] = useState("");

  // ============================================================
  // GENERATE QR CODE
  // ============================================================
  useEffect(() => {
    const generateQR = async () => {
      try {
        // ========================================================
        // QR CODE NOW LINKS TO LERROS CONTACT PAGE
        // Scanning this QR code will open the Lerros HQ contact page
        // ========================================================
        const qrData = "https://company.lerros.com/de/kontakt/zentrale";

        const qr = await QRCode.toDataURL(qrData, {
          width: 150,
          margin: 0,
          errorCorrectionLevel: "M",
        });

        setQrCode(qr);
      } catch (error) {
        console.error("QR Code generation error:", error);
        setQrCode("");
      }
    };

    generateQR();
  }, []);

  // const [before, totalCount] = content?.SNO?.split("/"); 
  // cons [noOfData, setNoOfData] = useState(1);
  // const noOfData = 
  // const [scale, setScale] = useState(0.7);
  const tbl = `
  <div class="table-main">
   <div class="table-child">
    <div class="table-row">
      <div class="common-first-cell article-cell">
        <div>ARTICLE NO.</div>
        <div class="common-first-cell first-inner-div">
          <h1>${content?.STY || "STY"}</h1>
        </div>
        <div class="">
          <hr class="hr-style-1" />
          NVE BARCODE
        </div>
      </div>
      <div class="common-first-cell color-cell">
        <div>COLOR</div>
        <div class="common-first-cell first-inner-div">
          <div><h2>${content?.CLRS[0] || "000"}</h2></div>
          <div><h2>${content?.CLRS[1] || ""}</h2></div>
          <div><h2>${content?.CLRS[3] ? "***" : content?.CLRS[2] || ""}</h2></div>
        </div>
      </div>
      <div class="common-first-cell lot-cell">
        <div>LOT</div>
        <div class="common-first-cell first-inner-div-lot">
          <div><h2>${content?.LOTS[0] || "000"}</h2></div>
          <div><h2>${content?.LOTS[1] || ""}</h2></div>
          <div><h2>${content?.LOTS[3] ? "***" : content?.LOTS[2] || ""}</h2></div>
        </div>
      </div>
      <div class="common-first-cell lot-count-cell">
        <div>NO. OF LOT</div>
        <div class="common-first-cell first-inner-div"><h2>${content?.NoOfLots || 1}</h2></div>
      </div>
      <div class="common-first-cell po-cell">
        <div>PO NUMBER</div>
        <div class="common-first-cell first-inner-div">
          <h1>${content?.PO || ""}</h1>
        </div>
      </div>
    </div>

    <div class="table-row">
      <div class="common-cell barcode-cell">
      <svg></svg>           
      <div class="table-row" style="padding: 0;">
          <div class="common-cell carton-and-qlt-pieces-cell" style="border-left: none;">
            <div>CARTON NO.</div>
            <!-- top, right, bottom, and left -->
            <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.SNO}</h3></div>
          </div>
          <div class="common-cell carton-and-qlt-pieces-cell">
            <div>QTY PIECES</div>
            <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.QtyPcs}</h3></div>
          </div>
          <div class="common-cell carton-and-qlt-pieces-cell">
            <div>GROSS WT(KG)</div>
            <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.GrossWt}</h3></div>
          </div>
          <div class="common-cell gross-and-net-wt-cell" style="border-right: none;">
            <div>NET WT(KG)</div>
            <div style="margin: 20px 0 0 0"><h3 style="font-size: 35px;">${content?.NetWt}</h3></div>
          </div>
        </div>
      </div>
      <div class="common-cell special-marking-cell-new">
        <div>SPECIAL MARKING/CUSTOMER PO NO</div>
       <div style="margin: 35px 0 33px -2px"><h3 style="font-size: 45px;">${content?.FCUS ? content?.FCUS : ' '}</h3></div>
      </div>
      <div class="common-cell lot-barcode-cell">
        <div>LOT BARCODE</div>
        <div style=" width:300px;padding :5px 0px 0px 30px ">
          
        </div>
        <div class= "lot-and-ean">
          <span>${content?.EAN[0]?.split("*")[1] || ""}</span> 
          <span>${content?.EAN[0]?.split("*")[0] || ""}</span>
        </div>
        
        <div style=" width:300px;padding :5px 0px 0px 30px ">
        
        </div>
        <div class= "lot-and-ean">
          <span>${content?.EAN[1]?.split("*")[1] || ""}</span> 
          <span>${content?.EAN[1]?.split("*")[0] || ""}</span>
        </div>
        <div style=" width:300px;padding :5px 0px 0px 30px ">
        
        </div>

        <div class= "lot-and-ean">
         <span>${content?.EAN[2]?.split("*")[1] || ""}</span> 
         <span>${content?.EAN[2]?.split("*")[0] || ""}</span>
        </div>
        <div class="carton-size-cell-new">      
                ${content?.DIM?.length > 0 ? (
      `<h3>DIM : ${content?.DIM}</h3>`
    ) : (
      `<h3>CARTON SIZES : ${`${content?.length || ""}*${content?.width || ""}*${content?.height || ""}`}</h3>`
    )}
        </div>
      </div>
    </div>

    <div class="table-row">
      <div class="common-cell carton-size-cell" style="margin: 0">
        <hr class="hr-style-2" />
        <div style="display: flex; height: 50%; width: 100%">
          <div
            style="
              height: 44px;
              width: 74px;
              margin: 5px 0 0 -6px;
              padding: 0;
            "
          >
            <h3
              class="text_fixed"
            >SIZES</h3>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          > <h2>${content?.header[0] || ""
    }</h2> </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          > <h2>${content?.header[1] || ""
    }</h2></div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
            ${content?.header[2] || ""
    }</h2>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
            ${content?.header[3] || ""
    }
            </h2>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
            ${content?.header[4] || ""
    }</h2>    
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
            ${content?.header[5] || ""
    }</h2>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
            ${content?.header[6] || ""
    }</h2>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
            ${content?.header[7] || ""
    }</h2>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
          ${content?.header[8] || ""
    }</h2>
            </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
          ${content?.header[9] || ""
    }</h2>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>
          ${content?.header[10] || ""
    }</h2>
          </div>
          <hr class="hr-style-3" />
          <div
            style="height: 44px; width: 74px; padding: 5px"
          ><h2>${content?.header[11] || ""
    }</h2></div>

          <hr class="hr-style-3" />
          <div
            style="
              height: 44px;
              width: 74px;
              margin: 15px 0 0 20px;
              padding: 0;
            "
          >
            <h3>TOTAL</h3>
          </div>
        </div>
        <hr class="hr-style-4" />
        <div style="display: flex; height: 100%; width: 100%; padding: 0; margin:0;">
          <div
            class="piesss-second"
          >
            <h3>PIECES</h3>
          </div>

          <div
            class="piesss-second"
          > <h2>${content?.TotalQtys[0] === 0 || content?.TotalQtys[0] === "0"
      ? ""
      : content?.TotalQtys[0] || ""
    }</h2></div>

          <div
          class="piesss-second"
          ><h2>${content?.TotalQtys[1] === 0 || content?.TotalQtys[1] === "0"
      ? ""
      : content?.TotalQtys[1] || ""
    }</h2></div>

          <div
          class="piesss-second"
          >
            <h2>${content?.TotalQtys[2] === 0 || content?.TotalQtys[2] === "0"
      ? ""
      : content?.TotalQtys[2] || ""
    }</h2>
          </div>

          <div
          class="piesss-second"
          ><h2>${content?.TotalQtys[3] === 0 || content?.TotalQtys[3] === "0"
      ? ""
      : content?.TotalQtys[3] || ""
    }</h2></div>

          <div
          class="piesss-second"
          ><h2>${content?.TotalQtys[4] === 0 || content?.TotalQtys[4] === "0"
      ? ""
      : content?.TotalQtys[4] || ""
    }</h2></div>

          <div
          class="piesss-second"
          ><h2>${content?.TotalQtys[5] === 0 || content?.TotalQtys[5] === "0"
      ? ""
      : content?.TotalQtys[5] || ""
    }</h2></div>

          <div
          class="piesss-second"
          ><h2>${content?.TotalQtys[6] === 0 || content?.TotalQtys[6] === "0"
      ? ""
      : content?.TotalQtys[6] || ""
    }</h2></div>

          <div
          class="piesss-second"
          ><h2>${content?.TotalQtys[7] === 0 || content?.TotalQtys[7] === "0"
      ? ""
      : content?.TotalQtys[7] || ""
    }</h2></div>

          <div
          class="piesss-second"
          ><h2>${content?.TotalQtys[8] === 0 || content?.TotalQtys[8] === "0"
      ? ""
      : content?.TotalQtys[8] || ""
    }</h2></div>
    <div
    class="piesss-second"
          ><h2>${content?.TotalQtys[9] === 0 || content?.TotalQtys[9] === "0"
      ? ""
      : content?.TotalQtys[9] || ""
    }</h2></div>
    <div
    class="piesss-second"
          ><h2>${content?.TotalQtys[10] === 0 || content?.TotalQtys[10] === "0"
      ? ""
      : content?.TotalQtys[10] || ""
    }</h2></div>
    <div
    class="piesss-second"
          ><h2>${content?.TotalQtys[11] === 0 || content?.TotalQtys[11] === "0"
      ? ""
      : content?.TotalQtys[11] || ""
    }</h2></div>
    <div class="piesss-second"
      ><h2>${content?.TotalQtys[12] === 0 || content?.TotalQtys[12] === "0"
      ? ""
      : content?.TotalQtys[12] || ""
    }</h2>
    </div>
        </div>
      </div>
    </div>
 </div>
   <div class="qr-main">
    <div class="carton-id">${content?.carton_ID}</div>
     <img
                    src="${qrCode}"
                    class="qr-code"
                    alt="QR Code"
                  />
   </div>
</div>
`



  // const tbl = `<div>checking 5</div>`

  const htmlContent = `<html lang="en">
    <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Complex Table with Flexbox</title>
    <style>
      .table-main {
        display: flex;
        justify-content: space-between;
        align-items: end;
      }
      .table-row {
        display: flex;
        align-items: start;
      }
      .common-cell {
        display: flex;
        flex-direction: column;
        text-align: center;
      }

      .common-first-cell {
        display: flex;
        flex-direction: column;
        text-align: center;

        height: 130px;
      }

      .article-cell {
        padding: 10px;

        text-align: center;
        width: 594px;
        height: 130px;
        border: 1px solid #000;
        border-bottom: none;
      }
      .color-cell {
        padding: 10px;

        width: 103px;
        height: 130px;
        border: 1px solid #000;
        border-left: none;
        border-right: none;
      }
      .lot-cell {
        padding: 10px;
        width: 110.5px;
        height: 130px;
        border: 1px solid #000;
      }
      .lot-count-cell {
        padding: 10px;
        width: 115px;
        height: 130px;
        border: 1px solid #000;
        border-left: none;
        border-right: none;
      }
      .po-cell {
        padding: 10px;

        width: 250px;
        height: 130px;
        border: 1px solid #000;
      }

      .first-inner-div {
        flex: 1;
        justify-content: center;
        align-items: center;
        height: 100%;
      }

      .first-inner-div-clr {
        flex: 1;
        justify-content: center;
        align-items: center;
        height: 100%;
      }

      .barcode-cell {
        padding: 10px 0 0 0;
        width: 594px;
        height: 260px;
        border: 1px solid #000;
        border-top: none;
      }

      .table-row{
        padding:0px
      }
      .carton-and-qlt-pieces-cell {
        padding: 10px;
        margin-top: 5px;
        width: 150px;
        height: 95px;
        border: 1px solid #000;
        border-bottom: none;
        border-right: none;
      }

      .special-marking-cell-new {
        padding: 5px;
        width: 211.6px;
        min-height: 260px;
        border: 1px solid #000;
        border-left: none;
        border-right: none;
        border-top: none;
      }

      .gross-and-net-wt-cell {
        padding: 10px;
        margin-top: 5px;
        width: 150px;
        height: 95px;
        border: 1px solid #000;
        border-bottom: none;
      }

      .lot-barcode-cell {
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        position: relative;
        padding: 10px;
        width: 367px;
        height: 260px;
        border: 1px solid #000;
        border-top: none;
      }

      .carton-size-cell {
        // padding: 0px 10px 10px 10px;
        width: 1172px;
        height: 115px;
        border: 1px solid #000;
        border-top: none;
      }

      .volume-measure-cell {
        padding: 0 10px 0 10px;
        width: 212px;
        height: 85px;
        border: 1px solid #000;
        border-right: none;
        border-left: none;
        border-bottom: 1px solid #000;
      }

      .special-marking-cell {
        padding: 10px;
        width: 361px;
        height: 65px;
        border-top: none;
        border: 1px solid #000;
        border-left: none;
      }

      .carton-size-cell-new {
        padding: 6px 0 0 0;
        margin: 0 -10px 0 -10px;
        height: 40px;
        border: none;
        border-top: 2px solid #000;
        margin-top: auto;
      }
      .carton-size-cell-new h3{
        font-size: 27px;
        font-weight:bolder;
      }
      .common-first-cell first-inner-div-lot, h2 {
        font-size: 21px !important;
        font-weight: 600 !important;
      }

      h1,
      h2,
      h3 {
        margin: 0;
        font-size: 15px;
        font-weight: 700;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      h1 {
        font-size: 50px;
        font-weight: 900;
      }
      h2 {
        font-size: 30px;
        font-weight: 600;
      }

      .hr-style-1 {
        border: 1px solid #000;
        margin: 33px -10px 10px -10px;
        width: calc(100% + 20px);
      }
      .hr-style-2 {
        // border: 1px solid #000;
        margin: 0px;
        width: 1170px;
        height: 1px;
        display:none
      }

      .hr-style-3 {
        height: 115px;
        border: 1px solid #000;
        margin: 0px 0 0px 0;
      }

      .hr-style-4 {
        margin: 0px 0px 0px 0px;
        width: 1170px;
        margin: 0;
        padding:4px !important;
      }

      .piesss-second{
        height: 44px;
        width: 74px;
        padding: 5px;
        margin-left:3px;
        display:flex;
        justify-content: center;
        align-items: center;
      }

      .tables-container {
        /* display: flex !important; */
        // border: 1px solid red;
        /* flex-direction: column-reverse; */
        width: 100%;
        height: 100vh;
        margin-bottom: 400px;
        overflow: visible;
        /* transform-origin: 700px top;
        transform: rotate(-90deg) translateX(-100%) scaleY(0.63) scaleX(0.8); */
      }
      

      .common-cell lot-barcode-cell {
        display: flex;
        flex-direction: row;
        justify-content: center;
      }
      .lot-and-ean {
        margin-left: 28px;
        width: 300px;
        padding: 5px;
        display: flex;
        justify-content: space-between;
      }
      .hr-style-16-container {
        display: flex;
        align-items: center;
        justify-content: center;
        margin: 30px 0px; /* top right bottom left */
        width: 1150px;
      }

      hr.style-16 {
        flex-grow: 1;
        border: none; /* Remove default border */
        border-top: 2px dashed black;
      }

      .hr-style-16-container span {
        display: inline-block;
        padding: 0 10px;
        background: #f0f0f0; /* Background color to overlap the line */
        font-size: 18px;
      }
      .qr-main {
  width: 150px;
  display: flex;
  justify-content: end;
  align-items: center;      /* QR ko center me rakhega */
  flex-direction: column;
}

/* QR ke same width (100px) ka wrapper banao, aur text ko left align karo */
.carton-id {
  width: 100px;             /* qr-code ki width ke barabar */
  padding: 0 0 10px 0;      /* left padding hata di */
  text-align: left;         /* QR ke starting point se start */
  font-weight: 500;
  white-space: nowrap;
}
    
      .qr-code {
        width: 100px;
        height: fit-content;
        display: block;
        object-fit: contain;
      }
    </style>

  </head>
      <body>
        <div class="tables-container">
              ${tbl}
                <div class="hr-style-16-container">
                  <hr class="hr-style-16">
                  <span>&#x2702;</span>
                  <hr class="style-16">
                </div>
              ${tbl}
        </div>
      </body>
  </html>`
  return (
    // <Modal.Body
    //       style={{
    //         height: 'auto',
    //         overflow: 'auto',
    //         padding: '4px',
    //         backgroundColor: '#f8f9fa',
    //         // border: '2px solid blue',
    //         boxShadow: '0 0 10px rgba(0,0,0,0.1)',
    //         display: 'flex',
    //         justifyContent: 'center',
    //         alignItems: 'center',
    //       }}
    //     >
    <div
      style={{
        width: 'auto',
        height: 'auto',
        overflow: 'visible',
        // transform: `scale(${scale})`,
        zoom: scale,
        padding: "100px",
        boxSizing: 'border-box',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
      dangerouslySetInnerHTML={{
        __html: htmlContent
      }}
    ></div>
    // </Modal.Body>

  );
};

export default PreviewLerros;